import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import {
  HOUSEHOLD_LISTING_STATUS_ARCHIVED,
} from 'common/householdConstants';

import {
  findHouseholdApplicationSubmission,
} from 'common/householdApplication/applicationHelpers';

import ListingCard from 'client/components/ListingCard';
import SrRenterApplicationStatusCardSection from 'client/components/SrRenterApplicationStatusCardSection';
import SrRenterApplicationStatusMessage from 'client/components/SrRenterApplicationStatusMessage';
import SrRenterApplicationStatusRoommatesListRow from 'client/components/SrRenterApplicationStatusRoommatesListRow';
import SrRenterApplicationInviteRoommateRow from 'client/components/SrRenterApplicationInviteRoommateRow';

import branch from 'client/core/branch';

@withRouter
@branch({
  listingPhotoResolution: ['listingPhotoResolution'],
  currentUser: ['currentUser'],
})
class SrRenterApplicationStatusCard extends Component {
  static propTypes = {
    listing: PropTypes.object.isRequired,
    market: PropTypes.object,
    household: PropTypes.object.isRequired,
    householdListing: PropTypes.object.isRequired,
    roommateApplications: PropTypes.array.isRequired,
    guarantorApplications: PropTypes.array.isRequired,
    applicationSubmissions: PropTypes.array.isRequired,
    onInviteRoommateClicked: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
    listingPhotoResolution: PropTypes.number.isRequired,
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  };

  render() {
    const {
      listing,
      market,
      household,
      householdListing,
      roommateApplications,
      guarantorApplications,
      applicationSubmissions,
      onInviteRoommateClicked,
      currentUser,
      listingPhotoResolution,
      dispatch,
      history,
    } = this.props;

    const isHouseholdListingArchived = (
      householdListing.status === HOUSEHOLD_LISTING_STATUS_ARCHIVED
      || household.status === HOUSEHOLD_LISTING_STATUS_ARCHIVED
    );

    return (
      <div className='SrRenterApplicationStatusCard'>
        <ListingCard
          key={listing.id}
          className={isHouseholdListingArchived ? 'archived' : null}
          listing={listing}
          currentUser={currentUser}
          showAutomatedListingStatus={false}
          showRequestShowingButton={false}
          showAvailableDate={false}
          photoResolution={listingPhotoResolution}
          disableDefaultApplicationStatusMessage
          showThumbnailListingAddress
        />
        <SrRenterApplicationStatusCardSection
          className={
            isHouseholdListingArchived
              ? 'lastSection'
              : null
          }
          title='application status'
        >
          <SrRenterApplicationStatusMessage
            householdListing={householdListing}
            roommateApplications={roommateApplications}
            customerSupportPhone={currentUser.customerSupportPhone}
            market={market}
          />
        </SrRenterApplicationStatusCardSection>
        {!isHouseholdListingArchived && (
          <SrRenterApplicationStatusCardSection className='lastSection' title='roommates applying'>
            <div className='SrRenterApplicationStatusRoommatesList'>
              {roommateApplications.map((app) => (
                <SrRenterApplicationStatusRoommatesListRow
                  key={`srasrlr-${app.id}`}
                  application={app}
                  dispatch={dispatch}
                  history={history}
                  currentUser={currentUser}
                  listing={listing}
                />
              ))}
              {guarantorApplications.map((app) => (
                <SrRenterApplicationStatusRoommatesListRow
                  key={`srasrlr-grtor-${app.id}`}
                  application={app}
                  applicationSubmission={findHouseholdApplicationSubmission({
                    applicationSubmissions,
                    applicationId: app.id,
                    listingId: listing.id,
                  })}
                  dispatch={dispatch}
                  history={history}
                  currentUser={currentUser}
                  listing={listing}
                  isGuarantor
                />
              ))}
              <SrRenterApplicationInviteRoommateRow
                listing={listing}
                householdId={householdListing.householdId}
                onInviteRoommateClicked={onInviteRoommateClicked}
              />
            </div>
          </SrRenterApplicationStatusCardSection>
        )}
      </div>
    );
  }
}

SrRenterApplicationStatusCard.displayName = 'SrRenterApplicationStatusCard';

export default SrRenterApplicationStatusCard;
